<template>
	<div class="impact-tool-feedback stage" :style="{ 'background-image': backgroundImage }">

		<div class="header__container">
			<div class="subHeader" style="position: relative">
				<span v-if="language == 'NL'">Verborgen impact</span>
				<span v-else-if="language == 'EN'">Hidden impact</span>
				<span v-else>Votre empreinte cachée</span>
			</div>
			<div class="header" style="position: relative">
				<span v-if="language == 'NL'">Resultaten</span>
				<span v-else-if="language == 'EN'">Results</span>
				<span v-else>Résultats</span>
			</div>
			<div class="text" style="position: relative" v-if="language == 'NL'">
				Als iedereen zou leven zoals <span class="green bold">jij</span> hebben we {{ totalsEarths }} aardes nodig. Je doet het dus <span v-if="totalsEarths > 3.6">slechter</span> <span v-else>beter</span> dan de <span class="pink bold">gemiddelde Nederlander</span>. Op naar binnen de draagkracht van de planeet: max. 1 aarde! Jouw impact compenseer je met het aanplanten van {{ treeCompensation }} bomen.
			</div>
			<div class="text" style="position: relative" v-else-if="language == 'EN'">
				If everybody would live like <span class="green bold">you</span> we need {{ totalsEarths }} Earths. So, you are doing it <span v-if="totalsEarths > 3.6">worse</span> <span v-else>better</span> than the <span class="pink bold">average Dutch person</span>. Let’s strive to stay within the capacity of the planet: max. 1 Earth! You can compensate your impact with planting {{ treeCompensation }} trees.
			</div>
			<div class="text" style="position: relative" v-else>
				Si tout le monde vit comme <span class="green bold">vous</span>, nous avons besoin de {{ totalsEarths }} terres. Vous faites <span v-if="totalsEarths > 3.6">moins bien</span> <span v-else>mieux</span> que le <span class="pink bold">Français moyen</span>. À l'intérieur de la capacité de charge de la planète: maximum 1 terre! Vous pouvez compenser votre impact en plantant {{ treeCompensation }} arbres.
			</div>
		</div>
		
		<div class="panel">
			 <div class="visual">
                <div class="visual--part left-side">
                    <div class="visual_earths earths_visual"></div>
                    <div class="visual_number">{{totalsEarths}}</div>
                </div>

                <div class="visual--part right-side">
                    <div class="visual_earths earths_visual_avg"></div>
                    <div class="visual_number">{{totalsEarthsAvg}}</div>
                </div>
            </div>
            
			<div class="legend">
                
				<div class="legend--part left-side">
                	<div class="visual_header green">{{ text_parts['jij'] }} <img class="visual-you" :src="baseUrl+roundData.questions.visual_you"/></div>
                </div>
                <div class="legend--part right-side">
                	<div class="visual_header pink">{{ text_parts['country'] }} <img class="visual-average" :src="baseUrl+roundData.questions.visual_average"/></div>
                </div>
            </div>


			<div v-for="(data, i) in ratios" class="group">
				
				<div class="group-header">{{data[2]}}</div>

                <div class="group-bar">

                    <div class="bar-part right-bar">
                        <div class="bar" :style="setWidth(data[1])"></div>
                    </div>

                    <div class="bar-part left-bar">
                        <div class="bar" :style="setWidth(data[0])"></div>
                    </div>
                </div>

			</div>


			<div style="height:auto; margin-bottom: 20px;" v-if="this.challengeToken">
				<a href="http://onefutureplay.com/my-challenges"><div class="btn btn-progres">Naar challenges</div></a>
			</div>

			<!-- <div class="share-impact" style="height:auto; margin-bottom: 20px;" v-if="language == 'NL'">

				<a v-if="totalsEarths > 3.6" target="new" href="https://www.facebook.com/sharer/sharer.php?u=http%3A//mijnverborgenimpact.nl&quote= Mijn Verborgen Impact is groter dan die van de gemiddelde Nederlander. Ik ben benieuwd naar die van jou! Ga naar www.mijnverborgenimpact.nl">Deel <i class="fa fa-facebook"></i></a>

				<a v-else target="new" href="https://www.facebook.com/sharer/sharer.php?u=http%3A//mijnverborgenimpact.nl&quote= Mijn Verborgen Impact is kleiner dan die van de gemiddelde Nederlander. Ik ben benieuwd naar die van jou! Ga naar www.mijnverborgenimpact.nl">Deel <i class="fa fa-facebook"></i></a>

			</div> -->
		</div>
	</div>
</template>

<script>

	import Vue from 'vue';
	import Lottie from '../../../Lottie.vue';
	import { url} from '../../../../const/base';
	import { api_url} from '../../../../const/base';
	import { lang } from '../../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		props:[
			'earths',
			'wholeEarths',
			'partlyEarth',
		],

		components:{
			Lottie,
		},

		beforeMount(){
			this.setFeedback();
		},

		mounted(){

			

			var wholeEarths = Math.floor(this.totalsEarths);
            var partlyEarth = this.totalsEarths - wholeEarths;

            for (var i = 0; i < wholeEarths; i++) {
                $('.earths_visual').append('<img class="first-earth" src="'+this.baseUrl+this.roundData.questions.visual_earth_you+'">');
            };

            if(partlyEarth > 0.1){
                $('.earths_visual').append('<img class="first-earth" src="'+this.baseUrl+this.roundData.questions.visual_half_earth_you+'">');
            }


            var wholeEarthsAvg = Math.floor(this.totalsEarthsAvg);
            var partlyEarthAvg = this.totalsEarthsAvg - wholeEarthsAvg;

            for (var i = 0; i < wholeEarthsAvg; i++) {
                $('.earths_visual_avg').append('<img class="first-earth" src="'+this.baseUrl+this.roundData.questions.visual_earth_average+'">');
            };

            if(partlyEarthAvg > 0.1){
                $('.earths_visual_avg').append('<img class="first-earth" src="'+this.baseUrl+this.roundData.questions.visual_half_earth_average+'">');
            }




			let sendObj = {
				"user_id": this.userId,
				"instance_id" : this.instanceId,
				"totalearths" : this.totalsEarths,
				"earthsPerGroup" : this.earthsPerGroup,
				"challenges_session_token": this.challengeToken,
			};

			console.log('challengeToken: '+this.challengeToken);

			if(this.challengeToken){
				this.$socket.emit('finished impactchallenge', sendObj);
			}

			Vue.http.post(this.apiUrl + 'api/v2/savesimpact' , sendObj).then(response => {
				//console.log(response.status);
				//console.log("lol");
				//console.log(response.statusText);
				//console.log(response.body);
			}).catch(response => {
				//console.log("Error: ");
				//console.log(response);
			});

		        
			if(this.challengeToken){
				this.hideNextButton();
			}else{
				
				setTimeout(()=>{
					this.setNextButtonAction(this.lastRound ? this.toNextStage : this.toNextRound).then(()=>{
						this.showNextButton();
					});
				},500);

			}

				
		},

		data(){
			return {
				language: lang,
				baseUrl : url,
				apiUrl: api_url,
				feedbackArray : [],
				averagesArray: [],
		        pointsArray: [],
		        earthsArray: [],
		        userPoints: [],
				earthsPerItem: [],
				totalsPointDivider: 0,
				totalsEarths: 0,
				treeCompensation: 0,
				earthsPerGroup: [],
				earthsPerGroupAvg: [],
				totalPointsAvg: 832,
				totalsEarthsAvg: 3.6,
				ratios:[],
				highest_value: 0,
				labels:["Spullen", "Vlees", "Zuivel & eieren", "Plantaardig, vis & drinken", "Auto", "Vliegen", "Openbaar Vervoer", "Wonen", "Badkamer"],
				text_parts: {'jij': 'Jij', 'country': 'NL'}
			}
		},
		methods:{
			...mapActions([
				"setNextButtonAction",
				"showNextButton",
				"hideNextButton",
				"toNextStage",
				"toNextRound",
				"setUserImpact"
			]),

			setWidth(value){
				return "width: "+value+"%";
			},

			setLabels() {

				if(lang == 'FR'){
					this.labels = ["Objets", "Viande", "Produits laitiers & Oeufs", "Aliments d'origine végétale", "Voiture", "L’avion", "Transports en commun", "Chez vous", "Douche"];
					
					this.text_parts = {'jij': 'Vous', 'country': 'FR'};

					this.totalPointsAvg = 954;
					this.totalsEarthsAvg = 3.0;

				}else if(lang == 'EN'){
					this.labels = ["Stuff", "Meat", "Dairy products & eggs", "Vegetable, fish & drinks", "Car", "Airplane", "Public transport", "Home", "Bathroom"];
					
					this.text_parts = {'jij': 'You', 'country': 'NL'};

					this.totalPointsAvg = 832;
					this.totalsEarthsAvg = 3.6;

				}
			},

			calculatedAveragesArray() {

				//loop over the questions and push each value to the array

				for (var i = 0; i < this.roundData.questions.questions.length; i++) {

					this.averagesArray.push(parseFloat(this.roundData.questions.questions[i].average));
				}

				console.log('calculatedAveragesArray');
				console.log(this.averagesArray);
			},

			calculatedPointsArray() {

				//loop over the questions and push each value to the array

				for (var i = 0; i < this.roundData.questions.questions.length; i++) {

					this.pointsArray.push(parseFloat(this.roundData.questions.questions[i].points));
				}
			},

			calculatedEarthsArray() {

				//loop over the questions and push each value to the array

				for (var i = 0; i < this.roundData.questions.questions.length; i++) {

					this.earthsArray.push(parseFloat(this.roundData.questions.questions[i].earths));
				}
			},

			setFeedback(){

				this.setLabels();

				this.calculatedAveragesArray();

				this.calculatedPointsArray();

				this.calculatedEarthsArray();

				for(let i = 0 ; i < this.feedbackData.userAnswers.length; i++){

					let users_points = 0;
		            let users_earths = 0;
		            if(this.feedbackData.userAnswers[i] > 0){

		                const pointsDivider = this.averagesArray[i] / this.feedbackData.userAnswers[i];

		                users_points = this.pointsArray[i] / pointsDivider;
		                users_earths = this.earthsArray[i] / pointsDivider;
		            }

		            this.userPoints.push(users_points);
		            this.earthsPerItem.push(users_earths);

		        }

		        const total = this.userPoints.reduce(function(previousValue, currentValue){
					return currentValue + previousValue;
				});


		        this.treeCompensation = 0;

				if(total > 0){
		            this.totalsPointDivider = this.totalPointsAvg / total;
		            this.totalsEarths = this.totalsEarthsAvg / this.totalsPointDivider;
		            this.treeCompensation = Math.round( (this.totalsEarths/this.totalsEarthsAvg)*1946);
		        }else{
		            this.totalsPointDivider = 0;
		            this.totalsEarths = 0;
		        }

		        this.totalsEarths = parseFloat(Math.round(this.totalsEarths * 100) / 100).toFixed(2);



		        const group_0 = parseFloat(this.earthsPerItem[0]+this.earthsPerItem[1]).toFixed(2);
		        const group_1 = parseFloat(this.earthsPerItem[2]).toFixed(2);
		        const group_2 = parseFloat(this.earthsPerItem[3]+this.earthsPerItem[4]+this.earthsPerItem[5]).toFixed(2);
		        const group_3 = parseFloat(this.earthsPerItem[6]).toFixed(2);
		        const group_4 = parseFloat(this.earthsPerItem[7]).toFixed(2);
		        const group_5 = parseFloat(this.earthsPerItem[8]).toFixed(2);
		        const group_6 = parseFloat(this.earthsPerItem[9]).toFixed(2);
		        const group_7 = parseFloat(this.earthsPerItem[10]).toFixed(2);
		        const group_8 = parseFloat(this.earthsPerItem[11]).toFixed(2);





		        this.earthsPerGroup = [group_0, group_1, group_2, group_3, group_4, group_5, group_6, group_7, group_8];
		        console.log('earthsPerGroup: '+this.earthsPerGroup);



		        const group_0_avg = parseFloat(this.earthsArray[0]+this.earthsArray[1]).toFixed(2);
		        const group_1_avg = parseFloat(this.earthsArray[2]).toFixed(2);
		        const group_2_avg = parseFloat(this.earthsArray[3]+this.earthsArray[4]+this.earthsArray[5]).toFixed(2);
		        const group_3_avg = parseFloat(this.earthsArray[6]).toFixed(2);
		        const group_4_avg = parseFloat(this.earthsArray[7]).toFixed(2);
		        const group_5_avg = parseFloat(this.earthsArray[8]).toFixed(2);
		        const group_6_avg = parseFloat(this.earthsArray[9]).toFixed(2);
		        const group_7_avg = parseFloat(this.earthsArray[10]).toFixed(2);
		        const group_8_avg = parseFloat(this.earthsArray[11]).toFixed(2);

		        this.earthsPerGroupAvg = [group_0_avg, group_1_avg, group_2_avg, group_3_avg, group_4_avg, group_5_avg, group_6_avg, group_7_avg, group_8_avg];
		        console.log('earthsPerGroupAvg: '+this.earthsPerGroupAvg);


		        // this.ratios = [];

		        // const ratio_group_0 = ( group_0 / (group_0+group_0_avg) ) *100;
		        // const ratio_group_0_avg = ( group_0_avg / (group_0+group_0_avg) ) *100;
		        // this.ratios.push([ratio_group_0, ratio_group_0_avg, this.labels[0]]);



		        // const ratio_group_1 = ( group_1 / (group_1+group_1_avg) ) *100;
		        // const ratio_group_1_avg = ( group_1_avg / (group_1+group_1_avg) ) *100;
		        // this.ratios.push([ratio_group_1, ratio_group_1_avg, this.labels[1]]);


		        // const ratio_group_2 = ( group_2 / (group_2+group_2_avg) ) *100;
		        // const ratio_group_2_avg = ( group_2_avg / (group_2+group_2_avg) ) *100;
		        // this.ratios.push([ratio_group_2, ratio_group_2_avg, this.labels[2]]);


		        // const ratio_group_3 = ( group_3 / (group_3+group_3_avg) ) *100;
		        // const ratio_group_3_avg = ( group_3_avg / (group_3+group_3_avg) ) *100;
		        // this.ratios.push([ratio_group_3, ratio_group_3_avg, this.labels[3]]);


		        //new method

		        this.highest_value = 0;

	        	for(let i = 0 ; i < this.earthsPerGroup.length; i++){
		            
		            if(parseFloat(this.earthsPerGroup[i]) > this.highest_value){
		                this.highest_value = this.earthsPerGroup[i];

		                console.log(i+' of user now has highest value: '+this.highest_value);
		            }

		        }

		        for(let i = 0 ; i < this.earthsPerGroupAvg.length; i++){
		            
		            if(parseFloat(this.earthsPerGroupAvg[i]) > this.highest_value){
		                this.highest_value = this.earthsPerGroupAvg[i];

		                console.log(i+' of avg now has highest value: '+this.highest_value);
		            }

		        }

		        this.ratios = [];

		        const ratio_group_0 = (this.earthsPerGroup[0] / this.highest_value ) *100;
		        const ratio_group_0_avg = ( this.earthsPerGroupAvg[0] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_0, ratio_group_0_avg, this.labels[0]]);

		        const ratio_group_1 = (this.earthsPerGroup[1] / this.highest_value ) *100;
		        const ratio_group_1_avg = ( this.earthsPerGroupAvg[1] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_1, ratio_group_1_avg, this.labels[1]]);

		        const ratio_group_2 = (this.earthsPerGroup[2] / this.highest_value ) *100;
		        const ratio_group_2_avg = ( this.earthsPerGroupAvg[2] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_2, ratio_group_2_avg, this.labels[2]]);

		        const ratio_group_3 = (this.earthsPerGroup[3] / this.highest_value ) *100;
		        const ratio_group_3_avg = ( this.earthsPerGroupAvg[3] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_3, ratio_group_3_avg, this.labels[3]]);

		        const ratio_group_4 = (this.earthsPerGroup[4] / this.highest_value ) *100;
		        const ratio_group_4_avg = ( this.earthsPerGroupAvg[4] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_4, ratio_group_4_avg, this.labels[4]]);

		        const ratio_group_5 = (this.earthsPerGroup[5] / this.highest_value ) *100;
		        const ratio_group_5_avg = ( this.earthsPerGroupAvg[5] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_5, ratio_group_5_avg, this.labels[5]]);

		        const ratio_group_6 = (this.earthsPerGroup[6] / this.highest_value ) *100;
		        const ratio_group_6_avg = ( this.earthsPerGroupAvg[6] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_6, ratio_group_6_avg, this.labels[6]]);

		        const ratio_group_7 = (this.earthsPerGroup[7] / this.highest_value ) *100;
		        const ratio_group_7_avg = ( this.earthsPerGroupAvg[7] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_7, ratio_group_7_avg, this.labels[7]]);

		        const ratio_group_8 = (this.earthsPerGroup[8] / this.highest_value ) *100;
		        const ratio_group_8_avg = ( this.earthsPerGroupAvg[8] / this.highest_value ) *100;
		        this.ratios.push([ratio_group_8, ratio_group_8_avg, this.labels[8]]);


		        //console.log(this.ratios);


		        console.log('setUserImpact: '+this.totalsEarths);
		        this.setUserImpact(this.totalsEarths);


			}
		},
		computed:{
			...mapGetters([
				"questionData",
				"feedbackData",
				"lastRound",
				"instanceId",
				"userId",
				'roundData',
				"challengeToken",
			]),

			backgroundImage: function() {

				if(typeof this.roundData.questions.question_background === 'undefined' || this.roundData.questions.question_background === null){ 
					return 'none';
				}

		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

		},

	}
</script>

<style>

	.visual_earths img{
            width: 20px;
        }

</style>
<style scoped>


	
</style>


// WEBPACK FOOTER //
// src/components/minigames/feedback/impactcalculator/Index.vue